import React from 'react';
import './StarRating.css'; // Reuse the same CSS for stars

const StaticStarRating = ({ rating }) => {
  // Render stars based on the passed rating
  const renderStars = () => {
    return [...Array(5)].map((_, index) => {
      const starIndex = index + 1;
      const isFullStar = rating >= starIndex;
      const isHalfStar = rating === starIndex - 0.5;

      return (
        <div
          key={index}
          className={`star-container`}
          style={{ pointerEvents: 'none' }} // Ensure no interactivity
        >
          <div
            className={`star ${isFullStar ? 'full' : isHalfStar ? 'half' : ''}`}
          ></div>
        </div>
      );
    });
  };

  return <div className="static-star-rating">{renderStars()}</div>;
};

export default StaticStarRating;
